
import '../styles/Login.css';
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../assets/Logo-Negro.png';
import { FaBus } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import PoliticasVisionModal from './PoliticasVisionModal';

// En desarrollo usar backend local, en producción usar proxy
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:4005' : '');

const Login = () => {
  const [legajo, setLegajo] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPoliticasModal, setShowPoliticasModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [redirectPath, setRedirectPath] = useState('/home');
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      // Login 100% local (sin API externa)
      const loginResponse = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          usuario: legajo, 
          clave: password
        })
      });

      if (!loginResponse.ok) {
        const errorData = await loginResponse.json();
        throw new Error(errorData.error || 'Credenciales inválidas');
      }

      const loginData = await loginResponse.json();
      
      console.log('📦 Login response:', loginData);
      console.log('✅ success:', loginData.success);
      console.log('� isAdmin:', loginData.isAdmin);
      console.log('👤 Usuario:', loginData.isAdmin ? loginData.CdUsuario : loginData.Legajo);

      if (loginData.success) {
        let user;

        if (loginData.isAdmin) {
          // Usuario administrador
          user = {
            CdUsuario: loginData.CdUsuario,
            Usuario: loginData.Usuario,
            Nombre: loginData.Nombre,
            IdRol: loginData.IdRol,
            AdminLevel: loginData.AdminLevel,
            PortalRRHH: 1,
            isAdmin: true,
            tipoUsuario: 2 // Admin
          };
        } else {
          // Usuario empleado
          user = {
            Legajo: loginData.Legajo,
            CdEmpleado: loginData.CdEmpleado,
            Nombre: loginData.Nombre,
            IdRol: loginData.IdRol,
            isAdmin: false,
            tipoUsuario: (loginData.IdRol === 1 || loginData.IdRol === 99) ? 2 : 1
          };
        }
        
        console.log('💾 Guardando user:', user);
        console.log('🔑 Token JWT:', loginData.token);
        
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', loginData.token);

        // ============================================
        // VERIFICAR SI REQUIERE FIRMA DE POLÍTICAS
        // ============================================
        const destino = loginData.isAdmin ? '/administrador' : '/home';
        
        if (loginData.requiereFirmaPolitica) {
          console.log('📋 Requiere firma de políticas - mostrando modal');
          setUserData(user);
          setRedirectPath(destino);
          setShowPoliticasModal(true);
          setIsLoading(false);
        } else {
          console.log('✅ No requiere firma - navegando directamente');
          console.log('🎯 Navegando a:', destino);
          navigate(destino);
        }
      } else {
        console.error('❌ Login falló:', loginData);
        throw new Error('Error en login');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePoliticasAccepted = () => {
    console.log('✅ Políticas aceptadas - navegando a:', redirectPath);
    setShowPoliticasModal(false);
    navigate(redirectPath);
  };

  // ==================== VERSIÓN v1.0 (Bootstrap - Original) ====================
  return (
    <div className='back'>
      <div className={`cuadro ${isLoading ? 'loading-active' : ''}`}>
        <div style={{ maxWidth: '400px', margin: 'auto', padding: '2rem' }} className='div_f'>
          <div>
            <img src={Logo} alt="SiBus Logo" className='logo_css' />
          </div>
          <div className='encuadro'>
            <h2>Iniciar Sesión</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit} className='form_inputs'>
              <div>
                <label htmlFor="usuario">Usuario:</label><br />
                <input
                  id="usuario"
                  type="text"
                  value={legajo}
                  onChange={(e) => setLegajo(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
              <div className='PassW'>
                <label htmlFor="password">Contraseña:</label><br />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
              <button type="submit" className='btn_init' disabled={isLoading}>
                {isLoading ? 'Ingresando...' : 'Ingresar'}
              </button>
            </form>
            <div className="forgot-password-link">
              <Link to="/recuperar-contrasena">Cambiar contraseña</Link>
            </div>
          </div>
          {isLoading && (
            <div className="loading-overlay">
              <div className="loading-content">
                <FaBus className="pink-bus-icon" />
                <BeatLoader color="#ff00b3" size={15} />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Políticas y Visión */}
      <PoliticasVisionModal
        show={showPoliticasModal}
        onAccepted={handlePoliticasAccepted}
        userData={userData}
      />
    </div>
  );
};

export default Login;